import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "SiteSpyViewContainer wd100"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "wbg",
  style: {
    "height": "calc(100vh - 100px)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "PcSiteViewContainer wd100"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "wbg pd12 box colFlex brd6 ft14"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navs, (nv, nvi) => {
        return _openBlock(), _createElementBlock("div", {
          key: `nav_${nvi}`,
          onClick: $event => $data.curNav = nvi,
          class: _normalizeClass(`nav ${$data.curNav == nvi ? 'activeNav' : ''} mb12 pd6 box brd6 ptr`)
        }, [_createElementVNode("span", null, _toDisplayString(nv), 1)], 10, _hoisted_2);
      }), 128))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "colFlex box",
      style: {
        "padding-left": "12px",
        "overflow-y": "scroll"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [$data.curNav == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [$data.permissions.includes('PC_SPY') ? (_openBlock(), _createBlock(_component_EmdEnumValueListView, {
        key: 0,
        type: "SITE_SPY",
        "init-query": {
          type: 'SITE_SPY',
          extra: true
        },
        title: "竞对监控",
        "add-btn": "添加竞对网站"
      }, {
        extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.curNav == 1 ? (_openBlock(), _createBlock(_component_BatterTableDataView, {
        key: 1,
        "table-id": 6
      }, {
        siteName: _withCtx(data => [_createVNode(_component_el_tooltip, {
          effect: "dark",
          content: data.data.siteName,
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            truncated: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.data.siteName), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["content"])]),
        title: _withCtx(data => [_createVNode(_component_el_tooltip, {
          effect: "dark",
          content: data.data.title,
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            style: {
              "color": "#009FFF"
            },
            class: "ptr",
            onClick: $event => $options.viewPage(data.data),
            truncated: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.data.title), 1)]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1032, ["content"])]),
        keywords: _withCtx(data => [_createVNode(_component_el_tooltip, {
          effect: "dark",
          content: data.data.keywords,
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            truncated: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.data.keywords), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["content"])]),
        description: _withCtx(data => [_createVNode(_component_el_tooltip, {
          effect: "dark",
          content: data.data.description,
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            truncated: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.data.description), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["content"])]),
        _: 1
      })) : _createCommentVNode("", true)])]),
      _: 1
    })]),
    _: 1
  })]);
}